import React, { useState } from "react";
import { List, ListItem, IconButton, ListItemText, Typography, Divider, Stack, Alert } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfiniteScroll from "react-infinite-scroller";
import Checkbox from '@mui/material/Checkbox';



const SearchObjectiveList = (props) => {

    const handleChange = (event, item) => {
        // if (event.target.checked) {
        props.handleChange(event.target.checked, item.okrId);
        // }
    };


    const handleInfiniteOnLoad = () => {
        alert("called");
    }

    return (
        <div>
            {/* <InfiniteScroll
                dataLength={props.krResult.length}
                loadMore={handleInfiniteOnLoad}
                hasMore={true}
                threshold={400}
                scrollableTarget="scrollableDiv"
            > */}
            {props.krResult.length === 0 ? <Stack sx={{ width: '100%' }} spacing={2}><Alert severity="error">No Key Results Found</Alert></Stack> : props.krResult.map((item) => (
                <List className="stensil-para searchkr" sx={{ width: '100%', bgcolor: 'background.paper' }} >
                    <ListItem alignItems="flex-start">
                        <Checkbox
                            name={item.okrId}
                            onChange={(e) => handleChange(e, item)}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                        <ListItemText
                            primary={item.title}
                            className="search-heading1"
                            secondary={
                                <React.Fragment>
                                    {/* <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                    >
                                        Objective  :   {item.objectiveTitle !== null ? item.objectiveTitle : null}
                                    </Typography>
                                    <br /> */}
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                    >
                                        Owner Name :   {item.ownerName !== null ? item.ownerName : null}
                                    </Typography>

                                </React.Fragment>
                            }
                        />
                    </ListItem>
                </List>))}
            {/* </InfiniteScroll> */}
        </div>
    )
}
export default SearchObjectiveList;